const initialState = {
  sendOTP: {},
  isTimeout: false,
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SEND_OPT':
      return {
        ...state,
        sendOTP: { ...action.payload },
      };
    case 'TIMEOUT':
      console.log(action)
      return {
        ...state,
        isTimeout: true,
      }
    default:
      return state;
  }
};
export default reducer;
